<template>
    <div v-if="rate.brochure > 0 && rate.prijs < rate.brochure">
        Van <s>€ {{ rate.brochure }}</s> voor <br /><b
            >€ {{ rate.prijs }} p.p.</b
        >
    </div>
    <div v-else-if="rate.prijs > 0" style="line-height: 44px">
        v.a. € {{ rate.prijs }} p.p.
    </div>
    <div v-else="" style="line-height: 44px">
        Uitverkocht
    </div>
</template>

<script>
export default {
    name: 'Rate.vue',
    props: {
        rate: Object,
    },
}
</script>

<style scoped>
.hover:hover div,
.selected div {
    color: #fff;
}
</style>
